import React from 'react';

// Exact disclaimer text as specified in requirements
export const DISCLAIMER_TEXT = `This application is provided "as is," without warranties of any kind, express or implied. It is designed for personal budgeting only and does not provide financial, accounting, or investment advice. You are solely responsible for verifying the accuracy of your data and for any financial decisions made using the app.

All information is stored locally on your device or in a personal cloud service you configure. The developers of this app do not have access to your data and accept no liability for data loss, unauthorized access, or financial outcomes.

Use of this app constitutes acceptance of these terms.`;

interface DisclaimerTextProps {
  className?: string;
}

export function DisclaimerText({ className = '' }: DisclaimerTextProps) {
  return (
    <div className={`text-sm text-muted-foreground leading-relaxed ${className}`}>
      {DISCLAIMER_TEXT.split('\n\n').map((paragraph, index) => (
        <p key={index} className={index > 0 ? 'mt-4' : ''}>
          {paragraph}
        </p>
      ))}
    </div>
  );
}